export default __webpack_public_path__ + "static/media/sports1_hl.3b8dfb91.png";